<template>
  <div
    class="app-infos"
    v-loading="loading"
    element-loading-text="资源上传中"
    element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div style="width: 100%; background: #fff; padding: 20px">
      <div class="title-b">资源代传</div>
      <el-form :model="uploadForm" label-width="120px" size="small">
        <el-form-item label="上传资源类型">
          <el-select v-model="uploadForm.type" @change="handleClearAll">
            <el-option label="图片" value="1"></el-option>
            <el-option label="音频" value="2"></el-option>
            <el-option label="视频" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传资源">
          <uploadComponent
            @loading="uploadIng"
            ref="uploadRef"
            @fileList="getFileList"
            v-show="!selectedFiles.length"
            :resourceType="uploadForm.type"
            :fileLength="selectedFiles.length"
          ></uploadComponent>
          <resourceList
            @uploadResource="handleUploadResource"
            ref="imgOrVideoRef"
            :registerType="form.isRegistered"
            :resourceType="uploadForm.type"
            @clearAll="handleClearAll"
            :uploadFileList="selectedFiles"
            v-show="selectedFiles.length && uploadForm.type != '2'"
          >
          </resourceList>
          <audioList
            @uploadResource="handleUploadResource"
            ref="audiosRef"
            :registerType="form.isRegistered"
            @clearAll="handleClearAll"
            v-show="selectedFiles.length && uploadForm.type == '2'"
            :uploadFileList="selectedFiles"
          >
          </audioList>
        </el-form-item>
      </el-form>
      <!-- 右侧表单区域 -->
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-width="120px"
        size="small"
        class="work-submit-form"
      >
        <!-- 标题 -->
        <el-form-item label="标题" prop="title">
          <el-input
            show-word-limit
            v-model="form.title"
            placeholder="请输入标题，不超过25个字"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <!-- 核心关键词 -->
        <el-form-item
          label="核心关键词"
          prop="keywords"
          :show-message="!form.keywords"
        >
          <div class="keyword-count font-text">
            <!-- {{form.keywords?form.keywords.split(',').length:0}}/20关键词 -->
            <div class="keyword-count font-text">
              {{
                form.keywords
                  ? form.keywords
                      .split(/[,，]/)
                      .filter((item) => item.trim() !== "").length
                  : 0
              }}/20关键词
            </div>
          </div>
          <el-input
            show-word-limit
            type="textarea"
            v-model="form.keywords"
            placeholder="多个关键词请用，分隔"
            rows="5"
          ></el-input>
          <div class="recommended-keywords font-text">
            推荐关键词
            <span
              @click="handleKeywords(keyword)"
              v-for="(keyword, index) in recommendedKeywords"
              :key="index"
            >
              {{ keyword }}
            </span>
          </div>
        </el-form-item>
        <!-- 分类 -->
        <el-form-item label="分类" prop="category">
          <el-select v-model="form.category" placeholder="请选择">
            <el-option
              v-for="item in categorizeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 创作者 -->
        <el-form-item label="创作者" v-if="showCreate" prop="creator">
          <el-input
            show-word-limit
            type="text"
            v-model="form.creator"
            placeholder="请输入创作者"
            maxlength="50"
          >
          </el-input>
        </el-form-item>
        <!-- 朝代 -->
        <el-form-item label="朝代" prop="dynasty">
          <el-select v-model="form.dynasty" placeholder="请选择">
            <el-option
              v-for="item in dynastyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 艺术形态 -->
        <el-form-item label="艺术形态" prop="artForm">
          <el-select v-model="form.artForm" placeholder="请选择">
            <el-option
              v-for="item in artFormList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 详情 -->
        <el-form-item label="详情" prop="html" :show-message="!form.html">
          <Editor
            style="width: 100%; margin-top: 16px"
            :value.sync="form.html"
            ref="editor"
          />
        </el-form-item>
        <!-- 声明 -->
        <el-form-item label="" class="label-left">
          <el-checkbox v-model="form.agreement1">
            本人(本公司)承诺上传的作品为拥有著作权，若经审核发现为未经授权的恶意盗用、抄袭他人作品，与本人(本公司)承诺不符，愿意承担相应的责任并接受处罚。
          </el-checkbox>
        </el-form-item>
        <el-form-item label="" class="label-left">
          <el-checkbox v-model="form.agreement2">
            本人(本公司)已认真阅读并同意《用户服务协议》
          </el-checkbox>
        </el-form-item>
        <!-- 提交按钮 -->
        <el-form-item
          class="label-left"
          style="text-align: center; margin-top: 30px"
        >
          <el-button type="primary" @click="submitForm">提交审核</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import resourceList from "./resourceList.vue";
import audioList from "./audioList.vue";
import uploadComponent from "./uploadWb.vue";
import { getCategorize, getPicture, pordAdd } from "@/api/prod.js";
import { getSignContractStatus } from "@/api/newApi.js";
import Axios from "axios";
import Editor from "./editor";
import { artForm, dynasty } from "@/utils/dict";
export default {
  components: {
    resourceList,
    audioList,
    uploadComponent,
    Editor,
  },
  created() {
    // this.getCheckStatus();
    this.getCategorizeFn();
    this.getPictureFn();
  },
  mounted() {
    // 初始化时同步一次
    window.hasUnsavedUpload = this.hasUnsavedUpload;

    this.realName =
      this.$store.state.userInfo?.enterPriseCertification?.realName ||
      this.$store.state.userInfo?.certification?.realName ||
      "";
  },
  computed: {
    currentRef() {
      return this.uploadForm.type == "2" ? "audiosRef" : "imgOrVideoRef";
    },
    hasUnsavedUpload() {
      return !!this.selectedFiles.length;
    },
    showCreate() {
      return (
        this.categorizeList.find((item) => item.id == this.form.category)
          ?.name == "共创作品"
      );
    },
  },
  watch: {
    hasUnsavedUpload(val) {
      window.hasUnsavedUpload = val;
    },
  },
  beforeDestroy() {
    // 页面销毁时清理
    window.hasUnsavedUpload = false;
  },

  // 路由守卫 禁用不能进入
  //  async beforeRouteEnter(to, from, next) {
  //     console.log(`from---`, from);
  //     const token = localStorage.getItem("token") || localStorage.getItem("token")
  //     try {
  //         const res = await Axios.get(getSignContract,{
  //             headers: {
  //                     'Content-Type': 'application/json',
  //                     'Authorization':`Bearer ${token}`
  //                 }
  //         });
  //        console.log(`res-----------`, res);
  //        if(res.data.code == 200 && res.data.data &&  res.data.data.status != 4){
  //            next();
  //        }else{
  //         next(from.path);
  //        }
  //     } catch (err) {
  //         next(false); // 或处理错误导航
  //     }
  // },
  //路由守卫 未登录不能进入
  beforeRouteLeave(to, from, next) {
    const data = this.$refs[this.currentRef].getFileList();
    if (!data.length) return next();
    if (window.confirm("离开后将不保留已上传文件, 是否继续?")) {
      next();
    } else {
      next(false);
    }
  },
  data() {
    return {
      artFormList: artForm,
      dynastyList: dynasty,
      realName: "",
      uploadForm: {
        type: "1",
      },
      uploadType: "",
      selectedFiles: [],
      form: {
        isRegistered: "0",
        registrationNumber: "",
        certificate: "",
        title: "",
        keywords: "",
        category: "",
        creationDate: "",
        creationPlace: "",
        portraitRight: "1",
        agreement1: false,
        agreement2: false,
        creator: "",
        html: "",
        artForm: "",
        dynasty: "",
      },
      rules: {
        isRegistered: [
          {
            required: true,
            message: "请选择作品是否登记",
            trigger: "change",
          },
        ],
        registrationNumber: [
          {
            required: true,
            message: "请输入作品登记号",
            trigger: "blur",
          },
        ],
        creator: [
          {
            required: true,
            message: "请输入创作者",
            trigger: "blur",
          },
        ],
        html: [
          {
            required: true,
            message: "请输入详情",
            trigger: "change",
          },
        ],
        certificate: [
          {
            required: true,
            message: "请上传登记证书",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
          {
            max: 25,
            message: "标题不能超过25个字",
            trigger: "blur",
          },
        ],
        keywords: [
          {
            required: true,
            validator: this.validateKeywords,
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change",
          },
        ],
        artForm: [
          {
            required: true,
            message: "请选择艺术形态",
            trigger: "change",
          },
        ],
        dynasty: [
          {
            required: true,
            message: "请选择朝代",
            trigger: "change",
          },
        ],

        creationDate: [
          {
            required: true,
            message: "请选择创作完成日期",
            trigger: "change",
          },
        ],
        creationPlace: [
          {
            required: true,
            message: "请输入创作完成地点",
            trigger: "blur",
          },
          {
            max: 25,
            message: "创作完成地点不能超过25个字",
            trigger: "blur",
          },
        ],
        portraitRight: [
          {
            required: true,
            message: "请选择肖像权情况",
            trigger: "change",
          },
        ],
        agreement1: [
          {
            required: true,
            type: "boolean",
            message: "请勾选声明",
            trigger: "change",
          },
        ],
      },
      recommendedKeywords: [],
      categorizeList: [],
      loading: false,
    };
  },

  methods: {
    validateKeywords(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入关键词"));
      } else {
        // const keywordCount = value.split(',').length;
        // 用中英文逗号分割
        const arr = value.split(/[,，]/).filter((item) => item.trim() !== "");
        if (arr.length > 20) {
          callback(new Error("关键词数量不能超过20个"));
        } else if (value.length > 100) {
          // 额外添加字符长度限制
          callback(new Error("关键词总长度不能超过100个字符"));
        } else {
          callback();
        }
      }
    },
    updateFile() {
      this.$refs[this.currentRef].upDateFileList();
      this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
      const data = JSON.parse(
        JSON.stringify(this.$refs[this.currentRef].getFileList())
      );
      if (data.length == 0) {
        this.selectedFiles = [];
        this.$refs.form.resetFields();
        this.$router.push({
          path: "/contractManagement",
        });
      }
    },
    submitForm() {
      if (!this.form.agreement1) {
        this.$message.error("请勾选承诺声明");
        return;
      }
      if (!this.form.agreement2) {
        this.$message.error("请勾选用户服务协议");
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 这里可实现提交表单到后端的逻辑，比如使用axios
          const params = this.getImgOrVideoData();
          if (!params.length) {
            this.$message.error("请至少选择一个作品");
            return;
          }
          console.log("表单验证通过，提交数据", params);
          this.$ajax.post(pordAdd, params).then((res) => {
            if (res.data.code == 200) {
              this.$message.success(res.data.msg);
              // this.$router.push({
              //     path: '/myResources'
              // })
              // 不做调整，更新数据
              this.updateFile();
              return;
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log("表单验证不通过");
          return false;
        }
      });
    },
    getFileList(list) {
      // 判断当前有没有文件
      const data = this.$refs[this.currentRef].getFileList();
      this.selectedFiles = list;
      return;
      //判断是否data已经存在
      if (data.length) {
        // 过滤掉 url 相同的数据，同时处理 url 为空的情况
        this.selectedFiles = [
          ...data,
          ...list.filter(
            (item) =>
              !data.some(
                (existingItem) =>
                  existingItem.url && item.url && existingItem.url === item.url
              )
          ),
        ];
      } else {
        this.selectedFiles = list;
      }
    },
    handleClearAll() {
      this.selectedFiles = [];
      this.$refs.uploadRef.clearFiles();
    },
    getCertificate(data) {
      const { url, workFileName } = data;
      this.form.certificate = url;
      this.form.certificateName = workFileName;
    },
    handleKeywords(keyword) {
      let arr = [];
      if (this.form.keywords) {
        arr = this.form.keywords.split(",");
        // 判断是否有重复
        const isHas = arr.every((item) => item !== keyword);
        if (!isHas) return;
      }
      arr.push(keyword);
      this.form.keywords = arr.join(",");

      // 手动触发表单验证清除
      this.$nextTick(() => {
        this.$refs.form.validateField("keywords");
      });
    },
    handleClearFile() {
      this.form.certificate = "";
    },
    handleRegister() {
      this.$router.push({
        path: "/DigitalCopyrightRegistration",
      });
    },
    getCategorizeFn() {
      this.$ajax.get(getCategorize, { type: 4 }).then((res) => {
        if (res.data.code == 200) {
          this.categorizeList = res.data.data;
        }
      });
    },
    getPictureFn() {
      this.$ajax
        .get(getPicture, {
          type: 4,
        })
        .then((res) => {
          if (res.data.code == 200 && res.data.data) {
            // let arr = [];
            // arr = res.data.data.filter(v=>v.isPicture==1)
            this.recommendedKeywords = res.data.data.map((item) => item.name);
          }
        });
    },
    getImgOrVideoData() {
      const data = JSON.parse(
        JSON.stringify(this.$refs[this.currentRef].getFileList())
      );
      let params = [];

      if (data.length) {
        params = data
          .filter((key) => key.checked)
          .map((item) => {
            return {
              category: this.form.category,
              certificateUrl: this.form.certificate,
              finishAddress: this.form.creationPlace,
              finishTime: this.form.creationDate,
              isRegistered: this.form.isRegistered,
              keywords: this.form.keywords,
              portraitRight: this.form.portraitRight,
              registrationCode: this.form.registrationNumber,
              title: this.form.title,
              worksType: this.uploadForm.type,
              worksUrl: item.url,
              worksSize: item.workFileSize,
              duration: item.duration,
              fileName: item.workFileName,
              authType: "",
              frameImg: item.frameImg,
              ratio: item.ratio,
              resourceDesc: this.form.html,
              artForm: this.form.artForm,
              dynasty: this.form.dynasty,
              creator: this.form.creator,
              identityType: this.$route.query.identityType,
              identityAuthType: this.$route.query.identityAuthType,
              createBy: this.$route.query.createBy,
              status: 5,
              isSelfUpload: 0,
            };
          });
      }
      return params;
    },
    handleChangeRegister(val) {
      if (val == 1) {
        const data = JSON.parse(
          JSON.stringify(this.$refs.imgOrVideoRef.getFileList())
        );
        const checked = data.filter((key) => key.checked);
        if (checked.length > 1) {
          this.$message.error(
            "已登记作品需单独选择后提交证明材料，不支持批量提交"
          );
          this.form.isRegistered = "0";
        }
      }
    },
    handleUploadResource() {
      this.$refs.uploadRef.resetCount();
      const uploadComponent = this.$refs.uploadRef.getUploadRefDom();
      // 4. 找到内部的 input 元素
      const inputElement =
        uploadComponent.$el.querySelector('input[type="file"]');

      // 5. 触发点击事件
      if (inputElement) {
        inputElement.click();
      }
    },
    uploadIng(flag) {
      this.loading = flag;
    },
  },
};
</script>
<style lang="scss" scoped>
// 添加px转rem函数
@function px2rem($px) {
  /* @return ($px / 99.22) + rem; */
  @return $px + px;
}

.app-infos {
  justify-content: space-between;
  display: flex;
  width: 100%;
  height: 100%;
}

.left-section {
  width: 50%;
  padding: 0 px2rem(20) 0 0;
}

.bor {
  width: 1px;
  height: 100%;
  background-color: #d9d9d9;
}

.right-section {
  width: calc(50% - px2rem(100));
  padding: 0 px2rem(20);

  .file {
    color: #409eff;
  }

  .tip {
    position: absolute;
    top: 0;
    left: 200px;
    color: #409eff;
    cursor: pointer;
    font-size: px2rem(14);
  }
}

.work-upload-container {
  padding: px2rem(20);
  width: px2rem(600);
  margin: 0 auto;
}

/deep/ .el-radio__label {
  white-space: normal;
  /* 换行 */
}

/deep/ .el-checkbox__label {
  white-space: normal;
  /* 换行 */
}

.title-b {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  font-weight: 500;
  font-size: px2rem(16);
  color: #333333;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: px2rem(10);
}

/deep/.el-form-item__label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: px2rem(14);
  color: #666666;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

/deep/.el-button--primary {
  background: linear-gradient(180deg, #6877ff 0%, #4bbeff 100%);
  border-radius: px2rem(24);
  padding: px2rem(9) px2rem(30);
}

.upload-instructions {
  div {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: px2rem(14);
    color: #444444;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

.font-text {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: px2rem(14);
  color: #999999;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.recommended-keywords {
  margin-top: px2rem(20);

  span {
    background: rgba(78, 137, 255, 0.05);
    border-radius: px2rem(4);
    font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
    font-weight: 400;
    font-size: px2rem(14);
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding: px2rem(4) px2rem(10);
    margin-left: px2rem(20);
    cursor: pointer;
  }
}

.automatic {
  background: #f6f9ff;
  border-radius: 0px 0px 0px 0px;
  padding: px2rem(10);
  margin-bottom: px2rem(30);

  .automatic-tit {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: px2rem(14);
    color: #444444;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .automatic-count {
    margin-top: px2rem(10);
    display: flex;

    div {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: px2rem(14);
      color: #444444;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: px2rem(30);
    }
  }
}

/deep/.el-select,
/deep/.el-input {
  width: px2rem(440);
}

/deep/.el-select-dropdown {
  z-index: 11111 !important;
}

/deep/.label-left {
  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-checkbox__label {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: px2rem(14);
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .el-checkbox {
    display: flex;

    .el-checkbox__input {
      margin-top: px2rem(4);
    }
  }
}
</style>
